import { createFont, isWeb } from "tamagui";

// $true is the default value tamagui uses
export type FontSizeTokens =
  | "2xs"
  | "xs"
  | "sm"
  | "button"
  | "md"
  | "lg"
  | "xl"
  | "xxl"
  | "3xl"
  | "$true";
export const lineHeight: { [key in FontSizeTokens]: number } = {
  "2xs": 10,
  xs: 12,
  sm: 15,
  button: 17,
  md: 19,
  lg: 24,
  $true: 19,
  xl: 29,
  xxl: 39,
  "3xl": 58,
};
export const size: { [key in FontSizeTokens]: number } = {
  "2xs": 10,
  xs: 12,
  sm: 14,
  button: 14,
  md: 16,
  lg: 20,
  $true: 16,
  xl: 24,
  xxl: 32,
  "3xl": 48,
};

export default {
  "sans-serif": createFont({
    family: isWeb
      ? "Inter, -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif"
      : "Inter",
    size,
    lineHeight,
    letterSpacing: {
      $true: 0,
    },
    weight: {
      $true: "400",
    },
    face: {
      "400": { normal: "Inter-Regular" },
      "500": { normal: "Inter-Medium" },
      "600": { normal: "Inter-SemiBold" },
      "700": { normal: "Inter-Bold" },
    },
  }),
  serif: createFont({
    family: isWeb ? "PT Serif, Georgia, Times, Palatino, serif" : "PT Serif",
    size,
    weight: {
      $true: "400",
    },
    lineHeight,
    letterSpacing: {
      $true: 0,
    },
    face: {
      "400": { normal: "PTSerif-Regular" },
      "700": { normal: "PTSerif-Bold" },
    },
  }),
  monospace: createFont({
    family: isWeb
      ? "ui-monospace, SFMono-Regular, 'SF Mono', Menlo, Consolas, 'Liberation Mono', monospace"
      : "monospace",
    size,
    weight: {
      $true: "400",
    },
    lineHeight,
    letterSpacing: {
      $true: 0,
    },
  }),
};
